import PropTypes from 'prop-types'
import React from 'react'
import styles from './_friendGlobal.css'
import { FormattedMessage } from 'react-intl'

export function Friend ({ friendInfo, unfriendAction }) {
  const basicUserInfo = {
    displayName: friendInfo.display_name,
    id: friendInfo.id,
  }

  const profile = `/profile/${basicUserInfo.id}`
  const profileImage = `${profile}/picture?size=Medium`

  return (
    <div className={styles.friendContainer}>
      <div className={styles.friendInner}>
        <a href={profile}>
          <img className={styles.profileImage} src={profileImage} />
        </a>
        <div className={styles.friendName}>
          <a href={profile}>{basicUserInfo.displayName}</a>
          <a onClick={() => unfriendAction(basicUserInfo)} className={styles.unfriendLink}>
            <FormattedMessage id='friends.unfriendlink' defaultMessage='Unfriend' />
          </a>
        </div>
      </div>
    </div>
  )
}

Friend.propTypes = {
  friendInfo: PropTypes.shape({
    display_name: PropTypes.string,
    id: PropTypes.string,
  }),
  unfriendAction: PropTypes.func,
}

export default Friend
